module.exports = __webpack_public_path__ + "img/young-woman.87872751.png";